import { frontendURL } from 'dashboard/helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';

const AgendaWrapper = () => import('./AgendaWrapper.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/agenda'),
    name: 'agenda',
    component: AgendaWrapper,
    meta: {
      permissions: [...ROLES],
    },
  },
];

export const helenaRoutes = [
  {
    path: frontendURL('accounts/:accountId/agenda-helena'),
    name: 'agenda-helena',
    component: AgendaWrapper,
    meta: {
      permissions: [],
      public: true,
    },
  },
];
